import React, { useState } from 'react'
import { Card, CardContent, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from 'src/utils/Themes/colors'
import { get } from 'lodash'
import RiskCategorieContent from './RiskCategorieContent'
import Modal from 'src/components/common/Modal'
import HealthInsuranceDetails from 'src/components/RiskCategories/InsuranceDetails/HealthInsurance'
import DynamicInsuranceTemplate from 'src/components/RiskCategories/InsuranceDetails/DynamicInsuranceTemplate/DynamicInsuranceTemplate'
import { GROUP_INSURANCE_LIST } from 'src/utils/constants/common'
import { riskCategories } from 'src/utils/constants/RiskReports'

const RiskCategoriesDetails = ({ data }) => {
  const classes = useStyles()
  const [modalData, setModalData] = useState({})
  const [modalOpen, setModalOpen] = useState(false)
  const [showDetails, setShowDetails] = useState(false)
  const [insuranceName, setInsuranceName] = useState(null)
  const [insuranceSubType, setInsuranceSubType] = useState(null)

  const CloseModal = () => {
    setModalOpen(false)
    setModalData({})
  }

  const handleRiskCategory = (event, category) => {
    event.preventDefault()
    const riskData = get(data, category?.value, {})
    setModalData({
      title: category?.title,
      riskData: riskData,
      className: category?.value,
    })
    setModalOpen(true)
  }

  const handleInsuranceDetails = (insurance) => {
    setShowDetails(true)
    setInsuranceName(insurance?.insuranceName)
    setInsuranceSubType(insurance?.productSubType)
  }

  const handleCloseDetails = () => {
    setShowDetails(false)
    setInsuranceName(null)
    setInsuranceSubType(null)
  }
  const handleTotalCloseDetails = () => {
    setModalOpen(false)
    setShowDetails(false)
    setInsuranceName(null)
  }

  const isGroupInsurance = () => {
    return GROUP_INSURANCE_LIST?.includes(insuranceName)
  }

  return (
    <div>
      <div className={classes.riskCategoryWrapper}>
        {modalOpen ? (
          <Modal
            class={classes.modalRoot}
            bgcolor={COLORS?.WHITE}
            width={'94%'}
            left={'3%'}
            top={'5%'}
            ordered={modalOpen}
            modelClosed={CloseModal}
          >
            <div className={classes.modalContent}>
              {showDetails ? (
                <div>
                  {isGroupInsurance() ? (
                    <HealthInsuranceDetails
                      id='healthInsuranceDetails'
                      title={modalData.title}
                      handleCloseDetails={handleCloseDetails}
                      handleTotalCloseDetails={handleTotalCloseDetails}
                      insuranceName={insuranceName}
                      subInsuranceType={insuranceSubType}
                    />
                  ) : (
                    <DynamicInsuranceTemplate
                      id='dynamicInsuranceDetails'
                      handleCloseDetails={handleCloseDetails}
                      handleTotalCloseDetails={handleTotalCloseDetails}
                      insuranceName={insuranceName}
                      riskTitle={modalData?.title}
                      subInsuranceType={insuranceSubType}
                    />
                  )}
                </div>
              ) : (
                <RiskCategorieContent
                  id='riskCategoryContent'
                  data={modalData}
                  handleClose={CloseModal}
                  handleClickEvent={(d) => handleInsuranceDetails(d)}
                />
              )}
            </div>
          </Modal>
        ) : null}
        <h2 className={classes.heading} id='top-risk-heading'>
          Insurance Insights
        </h2>
        <Grid container spacing={2} className={classes.item}>
          {riskCategories?.map((riskCategory, i) => {
            const { Icon, title } = riskCategory
            return (
              <Grid key={`category-${i}`} item xs={12} sm={6} md={4} lg={4}>
                <Card
                  classes={{ root: classes.root }}
                  onClick={(e) => handleRiskCategory(e, riskCategory)}
                  id={`cardClick-${i}`}
                >
                  <CardContent>
                    <div className={classes.category}>
                      <div className={classes.icon}>{<Icon />}</div>
                      <div className={classes.title}>{title}</div>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </div>
    </div>
  )
}

export default RiskCategoriesDetails

const useStyles = makeStyles({
  root: {
    borderRadius: '10px',
    border: `2px solid ${COLORS.WHITE}`,
    color: COLORS.GREY_10,
    '&:hover': {
      borderColor: COLORS.DARK_PINK,
      color: COLORS.DARK_PINK,
    },
  },
  riskCategoryWrapper: {
    marginTop: '24px',
  },
  item: {
    borderRadius: '10px',
    cursor: 'pointer',
  },
  category: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50px',
  },
  icon: {
    // width: "30px",
    marginRight: '14px',
    marginTop: '4px',
  },
  title: {
    fontSize: '15px',
    lineHeight: '18px',
    marginTop: '0px',
    color: 'inherit',
  },
  heading: {
    fontSize: '18px',
    lineHeight: '26px',
    marginTop: '0px',
    color: COLORS.GREY,
  },
  modalRoot: {
    height: '90%',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
})
